import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarService } from '@core/services/sidebar.service';
import { HeaderComponent } from '@shared/header/header.component';
import { NavSidebarComponent } from '@shared/nav-sidebar/nav-sidebar.component';
import { SubHeaderComponent } from '@shared/sub-header/sub-header.component';
import { AlertaComponent } from '@shared/alerta/alerta.component';

@Component({
  selector: 'app-layout',
  imports: [
    NavSidebarComponent,
    HeaderComponent,
    RouterOutlet,
    CommonModule,
    SubHeaderComponent,
    AlertaComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent {
  title = 'area_privada';
  constructor(public sidebarService: SidebarService) { }

  // TODO => MEJORAR ESTO
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const isValidClick =
      target.classList.contains('content') ||
      target.classList.contains('sub-header') ||
      target.classList.contains('panel') ||
      ['HEADER', 'TD', 'TH', 'TBODY', 'TR', 'TABLE', 'FORM', 'ASIDE'].includes(target.tagName);

    if (isValidClick && this.sidebarService.isOpen()) {
      this.sidebarService.sideBarTooggle();
    }
  }

}
